import { EOfferSeller } from '../../../../api-models/common/json_query';

export const OFFER_SELLERS_MAP_VALUE_TO_LABEL = {
  [EOfferSeller.Agent]: 'От агентов',
  [EOfferSeller.Homeowner]: 'От собственников',
  [EOfferSeller.Builder]: 'От застройщиков',
};
